<template>
    <div class="charge">
        <header class="charge-header">
            <div class="charge-header-date">
                <span>{{ year }}年</span>
                <span class="charge-header-date-month">{{ month }}月</span>
            </div>
            <div class="charge-header-pay">
                <span>支出</span>
                <span class="charge-header-pay-number">￥{{ totalPay }}</span>
            </div>
        </header>
        <main class="charge-content">
            <van-search v-model="searchChargeText" @input="searchCharge" placeholder="请输入搜索关键词" />
            <section class="charge-content-list" ref="messageList">
                <div class="charge-content-list-item" v-for="charge in chargeList" :key="charge.id">
                    <div class="charge-content-list-item-time">{{ charge.time }}</div>
                    <div class="charge-content-list-item-count">{{ charge.role }}: {{ charge.name }}支出
                        <!-- <span class="charge-content-list-item-count" @touchstart="(e) => handleTouchStart(e, charge)" @touchend="handleTouchEnd"> -->
                            <span v-if="charge.count < 10" class="charge-content-list-item-count__1" @touchstart="(e) => handleTouchStart(e, charge)" @touchend="handleTouchEnd">
                            {{ charge.count }}</span>
                            <span v-if="charge.count >= 10 && charge.count < 100" class="charge-content-list-item-count__2" @touchstart="(e) => handleTouchStart(e, charge)" @touchend="handleTouchEnd">{{ charge.count }}</span>
                            <span v-if="charge.count >= 100 && charge.count < 1000" class="charge-content-list-item-count__3" @touchstart="(e) => handleTouchStart(e, charge)" @touchend="handleTouchEnd">{{ charge.count }}</span>
                            <span v-if="charge.count >= 1000 && charge.count < 10000" class="charge-content-list-item-count__4" @touchstart="(e) => handleTouchStart(e, charge)" @touchend="handleTouchEnd">{{ charge.count }}</span>
                            <span v-if="charge.count >= 10000 && charge.count < 100000" class="charge-content-list-item-count__5" @touchstart="(e) => handleTouchStart(e, charge)" @touchend="handleTouchEnd">{{ charge.count }}</span>
                        <!-- </span> -->

                        元
                    </div>
                </div>
            </section>
            <section class="charge-content-input">
                <div class="charge-content-input-content">
                    <div class="charge-content-input-content-info">
                        <input class="charge-content-input-content-info-name" type="text" v-model="name"
                            placeholder="名称">
                        <input class="charge-content-input-content-info-number" type="text" v-model="count"
                            placeholder="0.00">
                    </div>
                    <div class="charge-content-input-content-time" @click="openTimeSelector">
                        记录时间: {{ displayTime }} <span>(点击修改时间)</span>
                    </div>
                </div>
                <van-button class="charge-content-input-send" type="primary" size="normal"
                    @click="keepAccounts">记录</van-button>
            </section>
        </main>
        <van-datetime-picker v-if="showDate" v-model="selectTime" @cancel="showDate = false"
            @confirm="selectTimeConfirm" type="datetime" title="选择年月日" />

        <van-dialog v-model="showDeleteDialog" title="删除记录" showCancelButton @confirm="deleteCharge"
            @cancel="showDeleteDialog = false">
            <div class="delete-charge-dialog">
                <div>{{ deleteChargeItem?.record_time }}</div>
                <div>{{ deleteChargeItem?.role }}: {{ deleteChargeItem?.name }}支出{{ deleteChargeItem?.count }}元</div>
                <div></div>
            </div>
        </van-dialog>
    </div>
</template>

<script>
import {
    getChargeList,
    addChargeItem,
    deleteCharge
} from '../util/api'
export default {
    name: 'ChargeCom',
    data() {
        return {
            year: null,
            month: null,
            totalPay: 0,
            name: null,
            count: null,
            currentDate: null,
            selectTime: null,
            displayTime: null,
            searchChargeText: null,
            touchDeleteTimer: null,
            showDate: false,
            showDeleteDialog: false,
            originChargeList: [],
            chargeList: [],
            deleteChargeItem: null
        }
    },
    methods: {
        handleTouchEnd() {
            clearTimeout(this.pressTimer);
        },
        handleTouchStart(e, charge) {
            e.preventDefault();
            this.pressTimer = setTimeout(() => {
                this.deleteChargeItem = charge
                this.showDeleteDialog = true
            }, 1000);
        },
        deleteCharge() {
            deleteCharge({ id: this.deleteChargeItem.id }).then(() => {
                this.getChargeList()
            })
        },
        searchCharge() {
            if (!this.searchChargeText) {
                this.chargeList = this.originChargeList
            } else {
                this.chargeList = this.originChargeList.filter((charge) => charge.name.includes(this.searchChargeText))
            }
        },
        openTimeSelector() {
            this.showDate = true;
            this.selectTime = new Date()
        },
        selectTimeConfirm(date) {
            this.showDate = false
            this.displayTime = date.toLocaleString()
        },
        keepAccounts() {
            addChargeItem({
                role: this.$store.state.user?.display_name || '',
                name: this.name,
                count: Number(this.count),
                time: this.displayTime,
                recordTime: new Date().toLocaleString()
            }).then(() => {
                this.name = null;
                this.count = null;
                this.displayTime = new Date().toLocaleString();
                this.getChargeList()
            })
        },
        getChargeList() {
            const dateInfo = this.getCurrentMonthFirstAndLastDay();
            getChargeList({
                startDate: dateInfo.firstDay,
                endDate: dateInfo.lastDay
            }).then((list) => {
                const data = list.data.sort((a, b) => new Date(a.time) - new Date(b.time));
                this.originChargeList = [...data]
                this.chargeList = data
                this.totalPay = (this.chargeList.reduce((accumulator, currentValue) => {
                    return accumulator + currentValue.count;
                }, 0)).toFixed(2); 
                this.$nextTick(() => {
                    this.scrollToBottom()
                })
            })
        },
        scrollToBottom() {
            const messageList = this.$refs.messageList
            if (messageList) {
                messageList.scrollTop = messageList.scrollHeight
            }
        },
        getCurrentMonthFirstAndLastDay() {
            const now = new Date();
            const year = now.getFullYear();
            const month = now.getMonth();

            // 第一天
            const firstDay = new Date(year, month, 1);
            const firstDayFormatted = `${firstDay.getFullYear()}-${firstDay.getMonth() + 1}-${firstDay.getDate()}`;

            // 最后一天
            const lastDay = new Date(year, month + 1, 0);
            const lastDayFormatted = `${lastDay.getFullYear()}-${lastDay.getMonth() + 1}-${lastDay.getDate()}`;

            return {
                firstDay: firstDayFormatted,
                lastDay: lastDayFormatted
            };
        }
    },
    mounted() {
        this.displayTime = new Date().toLocaleString();
        this.year = new Date().getFullYear()
        this.month = new Date().getMonth() + 1
        this.getChargeList()
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.charge {
    display: flex;
    flex-direction: column;
    height: 100%;
    box-sizing: border-box;
    position: relative;
    background-color: #f5f5f5;
}

.charge-header {
    display: flex;
    height: 52px;
    padding: 0 24px;
    border-bottom: 1px solid #ececec;
    background-color: #fff;
}

.charge-header-date,
.charge-header-pay {
    position: relative;
    width: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: bold;
}

.charge-header-date-month {
    font-size: 14px;
}

.charge-header-date::before {
    content: "";
    position: absolute;
    right: 0;
    top: 18px;
    bottom: 18px;
    background-color: #1a1919;
    width: 1px;
}

.charge-header-pay {
    flex: 1;
}

.charge-header-pay-number {
    color: green;
}

.charge-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
}

.charge-content-list {
    padding: 12px 24px;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 24px;
    overflow-y: auto;
}

.charge-content-list-item {
    font-size: 12px;
}

.charge-content-list-item-time {
    font-size: 10px;
    color: #757272;
    text-align: center;
    margin-bottom: 8px;
}

.charge-content-list-item-count__1 {
    color: #818CF8;
}

.charge-content-list-item-count__2 {
    color: #22D3EE;
}

.charge-content-list-item-count__3 {
    color: #34D399;
}

.charge-content-list-item-count__4 {
    color: #F97316;
}

.charge-content-list-item-count__5 {
    color: #DB2777;
}

.charge-content-input {
    padding: 6px 12px;
}

.charge-content-input-content-info {
    display: flex;
}

.charge-content-input-content-info-name {
    flex: 1;
}

.charge-content-input-content-info-number {
    width: 52px;
    text-align: right;
}

.charge-content-input-content-time {
    font-size: 12px;
    background-color: #fff;
    padding: 0 6px;
    line-height: 24px;
}

.charge-content-input-content-time span {
    font-size: 10px;
    color: #a39b9b;
}

.charge-content-list-item-count{
    display: flex;
    align-items: center;
    line-height: 24px;
    gap: 4px;
}

.charge-content-input {
    display: flex;
    align-items: center;
    gap: 8px;
}

.charge-content-input-content {
    flex: 1;
    border-radius: 4px;
    overflow: hidden;
}

input {
    font-size: 12px;
    height: 36px;
    border: 0;
    box-sizing: border-box;
    padding: 6px 12px;
}

.van-datetime-picker {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
}

.delete-charge-dialog {
    text-align: center;
    font-size: 12px;
    padding: 12px 0 18px;
    color: #ff005e;
}
</style>
